import React from 'react'
import OpcionesTexto from './OpcionesTexto'
import OpcionesTitulo from './OpcionesTitulo'
import OpcionesBoton from './OpcionesBoton'

const OpcionesBannerSecundario = (props) => {
    return (
        <>
            <div className='mb-2'>
                <h4>Titulo</h4>
                <OpcionesTitulo {...props} />
            </div>
            <hr />
            <div className='mb-2'>
                <h4>Texto</h4>
                <OpcionesTexto {...props} />
            </div>

            <hr />
            <div className='mb-2'>
                <h4>Boton</h4>
                <OpcionesBoton {...props} />
            </div>
        </>
    )
}

export default OpcionesBannerSecundario